import { Image, Button } from "rsuite";
import { BUTTON_BLUE, BUTTON_GREEN, BUTTON_RED } from "../../utils/constants/images";
import logger from "../../utils/logger";
import "./button.css";

function BestStartButton({ text, color, width = 100, height = 50, onClick = () => {logger.warn('no click handler attached!')}, className, appearance='primary', "data-testid": dataTestId, ...props }) {
  return (
    <Button data-testid={`${dataTestId}-container`} className={`best-start-button ${className}`} style={{ width: width, height: height }} appearance={appearance} {...props}>
      <Image
        data-testid={dataTestId}
        fit="fill"
        width={width}
        height={height}
        onClick={onClick}
        src={color === "blue" ? BUTTON_BLUE : color === "red" ? BUTTON_RED : BUTTON_GREEN}
        alt={text}
        style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%" }}
      />
      <span
        onClick={onClick}
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          color: "white",
          fontWeight: "bold",
        }}
      >
        {text}
      </span>
    </Button>
  );
}

export default BestStartButton;
